import React from 'react'
import { IssueCard } from '@fareye/issue-resolution'
import queryString from 'query-string'
import { axiosInstance } from '@fareye/utils'
import { useTranslation } from '@fareye/common'

const IssueRaisedConfig = {
  children: {
    subscribe: {
      config: {
        apiConfig: {
          apiURL: `/api/v1/commontator/subscriptions`
        }
      }
    },
    showComments: {
      config: {
        apiConfig: {
          apiURL: '/api/v1/show_comments'
        }
      }
    },
    addComments: {
      config: {
        apiConfig: {
          apiURL: '/api/v1/commontator/threads'
        }
      }
    },
    issueListing: {
      config: {
        apiConfig: {
          apiURL: '/api/v1/issues'
        }
      }
    },
    category: {
      config: {
        apiConfig: {
          apiURL: `/api/v1/get_issue_category`
        }
      }
    },
    getUser: {
      config: {
        apiConfig: {
          apiURL: '/api/v1/alert_user_list'
        }
      }
    },
    addUser: {
      config: {
        apiConfig: {
          apiURL: `/api/v1/create_alert_user`
        }
      }
    },
    getAllIssue: {
      config: {
        apiConfig: {
          apiURL: `/api/v1/get_all_issues`
        }
      }
    },
    searchIssue: {
      config: {
        apiConfig: {
          apiURL: `/api/v1/search_issues`
        }
      }
    }
  },
  config: {
    links: {
      tripDetailsUrl: '/in-transit/trips'
    }
  }
}

export default function Issues({ issues, isShare }: any) {
  const searchParams = queryString.parse(location.search)
  const { token, issueId } = searchParams
  const { t } = useTranslation()
  const getSelectedIssue: any = React.useMemo(() => {
    return issues.find((ele: any) => ele.id == issueId)
  }, [issueId])
  function registerInterceptor() {
    return axiosInstance.interceptors.request.use(
      function(config: any) {
        config.headers['Accept'] = 'application/json'
        config.headers['Content-Type'] = 'application/json'
        const jwttoken = `Bearer ${token}`
        config.headers['Authorization'] = jwttoken
        return config
      },
      function(error) {
        // Do something with request error
        return Promise.reject(error)
      }
    )
  }

  React.useLayoutEffect(() => {
    const axiosInterceptor = registerInterceptor()
    return () => {
      axiosInstance.interceptors.request.eject(axiosInterceptor)
    }
  }, [])
  return (
    <>
      {getSelectedIssue ? (
        <IssueCard
          config={IssueRaisedConfig}
          baseUrl=""
          issue={getSelectedIssue}
          resourceType={''}
          t={t}
        />
      ) : null}
    </>
  )
}
